/// <amd-module name="Feed/Common/Types/MetricType" />
export enum MetricType {
    DownloadCount,
    UniqueUsers
}
